const { getModulesWithContainersPath } = require('~/webpack/require-context')

const requireContext = require.context(`containers/`, true, /^\/Assets\/js\/components\/[^/^\\]*\.js$/)
requireContext.keys().map(requireContext)
